const WORDS = [
  "CNC Machining", "Turning & Milling", "Iron Cutting", "Plasma & Laser", "CNC Wood Routing",
  "Teak Lotus Flowers", "Pooja Mandirs", "Custom Fabrication",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`font-display font-bold uppercase tracking-tight text-5xl sm:text-7xl lg:text-8xl px-6 sm:px-10 ${i % 2 ? "text-outline-silver" : "text-[#0e1116]"}`}>
          {w}
        </span>
        <span className="h-3 w-3 sm:h-4 sm:w-4 rotate-45 bg-gold-grad" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="marquee" aria-label="Services overview" className="relative py-10 sm:py-14 border-y border-slate-300/80 overflow-hidden bg-white/50">
    <div className="marquee-track">
      <Row />
      <Row />
    </div>
  </section>
);
